import * as React from "react";
import { createContext, useCallback, useContext } from "react";
import useSound from "use-sound";
import useLocalStorage from "../useLocalStorage";

interface SoundContextProps {
  enabled: boolean;
  setEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  playSound: (action: SoundAction) => void;
}

export const SoundContext = createContext<SoundContextProps>({
  enabled: true,
  setEnabled: () => {},
  playSound: () => {},
});
export const useSoundContext = () => useContext(SoundContext);

interface GameSoundProps {
  children: React.ReactNode;
}
export const GameSound = ({ children }: GameSoundProps) => {
  const [enabled, setEnabled] = useLocalStorage(true);
  const [playCardPlacedSound] = useSound(
    `${process.env.PUBLIC_URL}/sound/Card_placed.mp3`
  );
  const [playGameOverSound] = useSound(
    `${process.env.PUBLIC_URL}/sound/Defeat.mp3`
  );
  const [playVictorySound] = useSound(
    `${process.env.PUBLIC_URL}/sound/Victory.mp3`
  );
  const [playMyTurnSound] = useSound(
    `${process.env.PUBLIC_URL}/sound/Your_turn.mp3`
  );
  const [playNextTurnSound] = useSound(
    `${process.env.PUBLIC_URL}/sound/Next_turn.mp3`
  );
  const [playMagicSound] = useSound(
    `${process.env.PUBLIC_URL}/sound/Magic.mp3`
  );

  const playSound = useCallback(
    (action: SoundAction) => {
      console.log(action);
      if (!enabled) {
        return;
      }
      switch (action) {
        case "cardPlayed":
          playCardPlacedSound();
          break;
        case "gameOver":
          playGameOverSound();
          break;
        case "gameWon":
          playVictorySound();
          break;
        case "myTurn":
          playMyTurnSound();
          break;
        case "nextTurn":
          playNextTurnSound();
          break;
        case "magic":
          playMagicSound();
          break;
      }
    },
    [
      enabled,
      playCardPlacedSound,
      playGameOverSound,
      playVictorySound,
      playMyTurnSound,
      playNextTurnSound,
      playMagicSound,
    ]
  );

  return (
    <SoundContext.Provider value={{ playSound, enabled, setEnabled }}>
      {children}
    </SoundContext.Provider>
  );
};

type SoundAction =
  | "cardPlayed"
  | "gameOver"
  | "gameWon"
  | "myTurn"
  | "nextTurn"
  | "magic";
